export const USERLOGIN = 'LOGIN'
export const walletConnnected = 'walletConnnected'
export const DarkTheme = 'DarkTheme'
export const ForgetEmail = ''

